import { useDispatch, useSelector } from 'react-redux';
import FJModal from '../FJModal';
import FJProgressModal from './FJProgressModal';
import { setProgressModalData } from '../../../redux/slices/FJSliceModals.js';

const FJProgressModalContainer = () => {
    const dispatch = useDispatch();
    const { display, cancelCallback } = useSelector(state => state.modals.progressModalData);
    const progress = useSelector(state => state.modals.progress);

    const cancel = () => {
        cancelCallback && cancelCallback();
        dispatch(setProgressModalData({ display: false }));
    };

    return (
        <FJModal visible={display}>
            <FJProgressModal progress={progress} cancel={cancelCallback ? cancel : undefined} />
        </FJModal>
    );
};

export default FJProgressModalContainer;
